import { memo } from "react";
import { useTranslation } from "react-i18next";
import { StyledFooter } from "./footer.styled";
import Grid from "@mui/material/Grid";

const Footer = memo(() => {
  const { t } = useTranslation();

  // TODO change the following for the client
  return (
    <StyledFooter>
      <div>
        <span>
          <a
            className="footer-link"
            href="https://www.accenture.com/in-en/support/terms-of-use"
            target="_blank"
            rel="noreferrer"
          >
            {t("GLOBAL.TERMS_&_CONDITIONS")}
          </a>
        </span>
        <span>
          <a
            className="footer-link"
            href="https://www.accenture.com/us-en/support/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            {t("GLOBAL.PRIVACY_STATEMENT")}
          </a>
        </span>
      </div>
      <span className="copyright-text">
        <span>{t("GLOBAL.COPYRIGHT")}</span>
      </span>
    </StyledFooter>
  );
});

export default Footer;
